import { useCallback, useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import { useScript } from "usehooks-ts";

import { useMeQuery } from "@hd/api/auth/queries/useMeQuery";
import StepUpAuthModal from "@hd/auth/StepUpAuthModal";
import { useAuth } from "@hd/auth/useAuth";
import ContactPanel from "@hd/contact-panel/ContactPanel";
import NewConversationModal from "@hd/new-conversation-modal/NewConversationModal";
import RequestModal from "@hd/new-request-modal/RequestModal";
import HdLoader from "@hd/ui-kit/hd-loader/HdLoader";
import WhatsappModal from "@hd/whatsapp-modal/WhatsappModal";
import { useQueryClient } from "@tanstack/react-query";

import AIPanel from "../ai-panel/AIPanel";
import MiceQuotationRestoreModal from "../mice-quotation-restore-modal/MiceQuotationRestoreModal";
import Header from "./header/Header";
import Sidebar from "./sidebar/Sidebar";
import CommunicationsModal from "../modals/communications-modal/CommunicationsModal";
import DooryCustomKnowledgeModal from "../modals/doory-custom-knowledge-modal/DooryCustomKnowledgeModal";

function Layout() {
  const { logout, changeGroup, setIsChangingGroup } = useAuth();
  const { data: userData, isPending: userDataLoading } = useMeQuery();
  // console.log("Layout render with userData:", userData);

  const channelRef = useRef<BroadcastChannel | null>(null);
  const queryClient = useQueryClient();

  useScript(`//js-eu1.hs-scripts.com/25916624.js`, {
    removeOnUnmount: false,
    id: "hs-script-loader",
  });

  useEffect(() => {
    const channel = new BroadcastChannel("change-group-channel");

    channel.onmessage = () => {
      queryClient.resetQueries();
    };

    channelRef.current = channel;

    return () => {
      channel.close();
    };
  }, [queryClient]);

  const changeGroupHandler = useCallback(
    async (id: number) => {
      setIsChangingGroup(true);
      await changeGroup(id);
      // await refreshToken();
      // await queryClient.invalidateQueries({
      //   queryKey: meQueryKey(),
      // });
      await queryClient.resetQueries();
      window.postMessage("reloadframe", "*");
      channelRef.current?.postMessage(id);

      //Farlo qui o subito dopo await changeGroup?
      setIsChangingGroup(false);
    },
    [changeGroup, queryClient, setIsChangingGroup],
  );

  return userDataLoading || !userData ? (
    <HdLoader></HdLoader>
  ) : (
    <div className="flex flex-col h-full flex-grow" style={{ minWidth: 1280 }}>
      <Header
        userId={userData.userId}
        userFullName={userData.userFullName}
        // activeCompanies={userData.activeCompanies}
        activeGroupName={userData.selectedGroup.name}
        activeGroups={userData.activeGroups.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { sensitivity: "base" }),
        )}
        editUsersAndPermissions={userData.editUsersAndPermissions}
        logout={() => {
          logout();
        }}
        changeGroup={changeGroupHandler}
      />
      <div className="flex flex-grow relative overflow-hidden">
        <Sidebar items={userData.sections} />
        <div className="flex-grow bg-bodyBg flex flex-col overflow-hidden">
          <Outlet></Outlet>
        </div>
      </div>
      {/* <Footer></Footer> */}
      <ContactPanel
        loggedUserName={userData.username}
        loggedUserFullName={userData.userFullName}
      ></ContactPanel>
      <AIPanel
        loggedUserFirstName={userData.userFullName.split(" ")[0]} //TODO: Add UserFirstName to userData
      ></AIPanel>
      <WhatsappModal></WhatsappModal>
      <CommunicationsModal></CommunicationsModal>
      <NewConversationModal></NewConversationModal>
      <MiceQuotationRestoreModal></MiceQuotationRestoreModal>
      <StepUpAuthModal></StepUpAuthModal>
      <RequestModal></RequestModal>
      <DooryCustomKnowledgeModal></DooryCustomKnowledgeModal>
    </div>
  );
}

export default Layout;
